<template>
    <div>
        <div class="mb-3">
            <a :href="getEntityUrl(audit.idEntity, audit.entity)" 
                class="btn btn-outline-secondary"
                target="_blank" 
                v-show="shouldShowEntityLink">
                Ir para entidade
                <fa icon="external-link-alt" class="muven-external-link ml-1" />
            </a>
        </div>

        <div class="muven-column-layout">
            <div class="muven-column-left">
                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>Auditoria</p>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-8 mb-3">
                            <label>Atividade</label>
                            <p>{{audit.description}}</p>
                        </div>

                        <div class="col-12 col-md-4 mb-3">
                            <label>Data e hora</label>
                            <p>{{audit.date | dateTimeFilter}}</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-4 mb-3">
                            <label>Entidade</label>
                            <p>{{audit.getEntityEnumDescription()}}</p>
                        </div>

                        <div class="col-12 col-md-4 mb-3">
                            <label>Modificado por</label>
                            <p v-if="audit.getModificationSourceDescription()" class="audit-detail-actor">
                                <AuditActorTileCmp :kind="actorKindBySource(audit.modificationSource)" />
                                <span>{{audit.getModificationSourceDescription()}}</span>
                            </p>
                            <p v-else>-</p>
                        </div>

                        <div class="col-12 col-md-4 mb-3" v-show="audit.isFromAgent()">
                            <label>Canal</label>
                            <p v-if="channel.name">
                                <ChannelLogoCmp :channel="channel" :size="20" />
                            </p>
                            <p v-else>-</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-4 mb-3">
                            <label>Id muven</label>
                            <p>{{audit.idEntity}}</p>
                        </div>

                        <div class="col-12 col-md-8 mb-3">
                            <label>Id Client</label>
                            <p>{{audit.clientId}}</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-4 mb-3">
                            <label>Id do usuário</label>
                            <p>{{audit.userId | infoOrPlaceholder}}</p>
                        </div>

                        <div class="col-12 col-md-4 mb-3">
                            <label>Email do usuário</label>
                            <p>{{audit.userEmail | infoOrPlaceholder}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="muven-column-right">
                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>Status</p>
                    </div>

                    <div>
                        <p>{{audit.getStatusEnumDescription()}}</p>
                    </div>
                </div>

                <div class="muven-card mb-3"
                    :class="{
                        'muven-card-danger': audit.isSeverityHigh(),
                        'muven-card-warning': audit.isSeverityMedium(),
                    }">
                    
                    <div class="muven-card-title">
                        <p>Severidade</p>
                    </div>

                    <div>
                        <p>{{audit.getSeverityDescription()}}</p>
                    </div>
                </div>
            </div>

            <div class="muven-column-full">
                <div class="muven-card">
                    <div class="muven-card-title">
                        <p class="float-left">Dados trafegados</p>

                        <button class="btn btn-outline-secondary btn-sm float-right"
                            @click="downloadAuditHandler(audit)">
                            Baixar
                        </button>
                    </div>

                    <div v-show="audit.hasAdditionalData()">                        
                        <tree-view 
                            :deep="4"
                            :highlight-mouseover-node="true"
                            :show-length="true"
                            :data="audit.additionalData" />
                    </div>

                    <div v-show="!audit.hasAdditionalData()">
                        <p class="text-muted">Dados removidos devido ao tempo de expiração da auditoria.</p>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import {dateTimeFilter} from '@/utils/filters/DateTimeFilter'
import { AuditInstanceModel } from '../models/AuditInstanceModel'
import GetEntityUrl from '@/utils/mixins/GetEntityUrl'
import { infoOrPlaceholder } from '@/utils/filters/InformationOrPlaceholderFilter'
import { ChannelModel } from '@/channel/models/ChannelModel';
import ChannelService from '@/channel/services/ChannelService';
import DownloadJson from '../../utils/mixins/DownloadJson';
import AuditActorTileCmp from '@/audit/components/AuditActorTileCmp.vue'
import ChannelLogoCmp from '@/channel/components/ChannelLogoCmp.vue'
import { getAuditActorKindBySource } from '@/audit/models/AuditActor'

export default {
    name: 'AuditInstanceCmp',
    props: {
        audit: {
            type: AuditInstanceModel,
            default: new AuditInstanceModel(),
        },
        channel: {
            type: ChannelModel,
            default: new ChannelModel(),
        },
    },
    components: {
        'tree-view': VueJsonPretty,
        AuditActorTileCmp,
        ChannelLogoCmp,
    },
    mixins: [
        GetEntityUrl,
        DownloadJson,
    ],
    filters: {
        dateTimeFilter,
        infoOrPlaceholder,
    },
    methods: {
        actorKindBySource(source) {
            return getAuditActorKindBySource(source)
        },
        downloadAuditHandler(audit) {
            this.downloadJSON(audit, `Auditoria ${audit.getEntityEnumDescription()} - ${audit.date.toISOString()}.json`)
        },
    },
    computed: {
        shouldShowEntityLink() {
            if (!this.audit.hasIdEntity()) {
                return false
            }

            return this.audit.isEntityOrder() ||
                   this.audit.isEntityProduct() ||
                   this.audit.isEntityCategory() ||
                   this.audit.isEntityBrand() 
        }
    },
}
</script>

<style scoped>
.audit-detail-actor {
    display: flex;
    align-items: center;
    gap: 8px;
}
</style>
